import { ReactElement } from 'react';

import styles from './styles.module.scss';

interface LogoContainerProps {
  logo: string;
  paymentMethodName: string;
}

export const PaymentMethodLogo = ({
  logo,
  paymentMethodName,
}: LogoContainerProps): ReactElement => (
  <div className={styles.wrapper}>
    <img src={logo} alt={paymentMethodName} data-test="payment-logo" />
  </div>
);
